import { createBooleanStore } from '@stores/create-boolean-store';

const panelStore = createBooleanStore('ai-builder-panel-open', true);

export const useAiBuilderPanelStore = panelStore.useStore;
export const setAiBuilderPanelOpen = panelStore.setValue;
